import { useCallback } from 'react';

import { useMutation } from '@tanstack/react-query';
import { type Address } from 'viem';

import { type FeasibilityResponse, type MutationSubmitTransactionArgs } from '@pkg/graphql/codegen/graphql';
import { usePetraWallet } from '@pkg/hooks/wallets/usePetraWallet';

import { callSubmitTransaction } from '@app/client/resources/marketplace';

export function useSubmitAptosTransaction() {
    const { handleTransaction } = usePetraWallet();
    const { mutateAsync } = useMutation({
        mutationFn: ({ variables }: { variables: MutationSubmitTransactionArgs }) =>
            callSubmitTransaction({ variables }),
    });

    return useCallback(
        async (prepareRes: FeasibilityResponse, account: Address) => {
            if (prepareRes && account) {
                const transaction = prepareRes.origin;
                const signed = await handleTransaction(transaction);
                return mutateAsync({
                    variables: {
                        orderId: prepareRes.orderId,
                        signedTransaction: signed,
                    },
                })
                    .then((r) => {
                        if (r.submitTransaction) {
                            return r.submitTransaction;
                        } else {
                            return false;
                        }
                    })
                    .catch((_e) => false);
            }
        },
        [handleTransaction, mutateAsync],
    );
}
